import httpCommon from "@/axios/chat/http-common";
import qs from "qs";

const EmotionService = {
    /**
     * API lấy tất cả dữ liệu Emotion
     * */
    getAll: (page, limit, search) => {
        return httpCommon.get("system/icon", {
            params: {
                page: page,
                limit: limit,
                search: search
            }
        });
    },

    /**
     * API tạo mới Emotion
     * */
    create: async (data) => {
        return await httpCommon.post("system/icon", data);
    },

    /**
     * Chỉnh sửa Emotion
     * */
    update: async (data) => {
        return await httpCommon.put("system/icon", data);
    },

    updateActive: async (data) => {
        return await httpCommon.put("system/icon/active", data);
    },

    updateDefault: async (data) => {
        return await httpCommon.put("system/icon/default", data);
    },

    delete: async (ids) => {
        return await httpCommon.delete("system/icon", {
            params: {
                ids: ids // mảng
            },
            paramsSerializer: params => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            }
        });
    }
}

export default EmotionService;
